/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { withJsonFormsEnumProps } from '@jsonforms/react'
import { RadioControl } from '../RadioControl'
import { RadioButtonsControl } from '../RadioButtonsControl'

export interface CustomRadioControlProps {
  data: any
  handleChange(path: string, value: any): void
  path: string
  schema: any
  label: any
  errors: string
  visible: boolean
  uischema: any
  enabled: boolean
}

const RadioHocControl = ({
  data,
  handleChange,
  path,
  schema,
  label,
  errors,
  visible,
  uischema,
  enabled
}: CustomRadioControlProps) => {
  const toRender = () => {
    return schema.isCustomRadioButtons ? (
      <RadioButtonsControl
        value={data}
        path={path}
        schema={schema}
        data={data}
        label={label}
        updateValue={(newValue: string) => handleChange(path, newValue)}
        errors={errors}
        visible={visible}
        enabled={enabled}
      />
    ) : (
      <RadioControl
        value={data}
        path={path}
        schema={schema}
        data={data}
        label={label}
        updateValue={(newValue: string) => handleChange(path, newValue)}
        errors={errors}
        visible={visible}
        uischema={uischema}
        enabled={enabled}
      />
    )
  }

  return <div>{toRender()}</div>
}

export default withJsonFormsEnumProps(RadioHocControl)
